import { Skeleton } from 'antd'
import styles from './styles.module.scss'

interface TextSkeletonProps {
  rows?: number
  showTitle?: boolean
  titleWidth?: string
  width?: string
}

export function TextSkeleton({
  rows = 1,
  showTitle,
  titleWidth = '6rem',
  width = '100%',
  ...props
}: TextSkeletonProps) {
  const titleProps = { width: titleWidth }

  return (
    <div {...props}>
      <Skeleton
        className={styles.container}
        active
        paragraph={{ rows, width }}
        round
        title={!!showTitle && titleProps}
      />
    </div>
  )
}
